import LazyImages from "../modules/LazyImages";
import { getPersonalizationCampaigns } from "../services/personalization.service";
import { getAlternateTemplate } from "../services/template.service";
class MainNavMobile extends HTMLElement {
    constructor() {
        super();
    }
    async connectedCallback() {
        var _a, _b, _c;
        console.log("MainNavMobile : connectedCallback");
        try {
            this.configId = null;
            if ((_a = window.UTK_themeConfig) === null || _a === void 0 ? void 0 : _a.mainNavigationPersonalizationMobile) {
                const selectorName = (_b = window.UTK_themeConfig) === null || _b === void 0 ? void 0 : _b.mainNavigationPersonalizationMobile.apiSelectorName;
                const personalizationResults = await getPersonalizationCampaigns({ apiSelectorNames: [selectorName] });
                const decision = personalizationResults.choices.find((c) => c.name.toLowerCase() === selectorName.toLowerCase());
                if (decision === null || decision === void 0 ? void 0 : decision.variations) {
                    const payloadData = decision.variations[0].payload.data;
                    if (payloadData) {
                        const id = payloadData.id;
                        const variation = (_c = window.UTK_themeConfig) === null || _c === void 0 ? void 0 : _c.mainNavigationPersonalizationMobile.variations.find((v) => v.variationId.toLowerCase() === id.toLowerCase());
                        if (variation) {
                            this.configId = variation.variationId;
                        }
                    }
                    else {
                        console.log("user served control");
                    }
                }
            }
        }
        catch (e) {
            console.error("Error parsing config", e);
        }
        finally {
            console.log("MainNavMobile : rendered config", this.configId);
            this.render();
        }
    }
    async render() {
        const queryParams = {};
        if (this.configId) {
            queryParams["variation-id"] = this.configId;
        }
        const currentQueryParams = new URLSearchParams(window.location.search);
        if (currentQueryParams.has("preview-theme")) {
            queryParams["preview-theme"] = currentQueryParams.get("preview-theme");
        }
        const template = await getAlternateTemplate('', 'menu-mobile', queryParams);
        if (template) {
            this.innerHTML = template;
            LazyImages.update();
        }
        else {
            console.error("MainNavMobile : unable to fetch template");
        }
    }
}
if (!window.customElements.get("main-nav-mobile")) {
    customElements.define("main-nav-mobile", MainNavMobile);
}
